// Generated by uRequire v0.7.0-beta.15 target: 'dist' template: 'nodejs'
(function () {
  
var __isAMD = !!(typeof define === 'function' && define.amd),
    __isNode = (typeof exports === 'object'),
    __isWeb = !__isNode;


module.exports = (function () {
  var linear;
  linear = function (arg, arg1) {
    var a, b, c, d, f;
    a = arg[0], b = arg[1];
    c = arg1[0], d = arg1[1];
    f = function (x) {
      return c + (d - c) * (x - a) / (b - a);
    };
    f.inverse = function () {
      return linear([
        c,
        d
      ], [
        a,
        b
      ]);
    };
    return f;
  };
  return linear;
}).call(this);


}).call(this)


/*****************
 ** WEBPACK FOOTER
 ** ./~/paths-js/linear.js
 ** module id = 180
 ** module chunks = 0
 **/